import { useCallback, useContext } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { ConfigContext } from 'Context/config';
import { VehicleLookupContext } from 'Context/vehicleLookup';

import { VALUATIONS_GA_TAGS } from 'Utilities/analytics';
import { FLAG } from 'Utilities/analytics/optimizely/constants';

import { PATHS } from '../../homepage/Components/Hero/Hero.constants';

import { mileageExperimentFlag } from './MileageExperiment.helpers';

export const useMileageRemovalExperiment = () => {
  const { vehicleLookupActions } = useContext(VehicleLookupContext);

  const { optimizely } = useContext(OptimizelyContext);
  const { configState: { experimentDecisions } } = useContext(ConfigContext);
  const experimentVariant = experimentDecisions?.[FLAG.MW_4_1_MILEAGE_REMOVAL] ?? 'off';

  const triggerExperimentDecision = useCallback(() => {
    optimizely?.onReady().then(() => {
      if (experimentDecisions?.[FLAG.MW_4_1_MILEAGE_REMOVAL]) {
        optimizely.decide(FLAG.MW_4_1_MILEAGE_REMOVAL);
      }
    });
  }, [experimentDecisions, optimizely]);

  const getMileagePath = useCallback((pathname?: string, payload?: { mileage?: number; vrm: string }) => {
    const defaultPath = pathname === PATHS.home ? PATHS.mileage : `${pathname}${PATHS.mileage}`;

    if (!payload?.mileage) {
      return defaultPath;
    }

    triggerExperimentDecision();

    if (experimentVariant !== 'on') {
      return defaultPath;
    }

    // Artificially update the vehicle lookup state with mileage
    vehicleLookupActions.update({
      enquiry: {
        mileage: payload.mileage,
      },
    });

    // VEHICLE_LOOKUP_COMPLETE usually runs on mileage step load
    VALUATIONS_GA_TAGS.VEHICLE_LOOKUP_COMPLETE(payload.vrm);

    mileageExperimentFlag.set(payload.vrm);

    // Redirect to /:vrm where authn will pick up the pieces
    return pathname === PATHS.home ? `/${payload.vrm}` : `${pathname}/${payload.vrm}`;
  }, [experimentVariant, triggerExperimentDecision, vehicleLookupActions]);

  return { getMileagePath };
};
